import { ReactElement, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import Loader from "uicomponents/Loader";
import AuthModel from "./AuthModel";
interface IProtectedRouteProps {
  children: ReactElement;
}

const RequiredAuth = ({ children }: IProtectedRouteProps): ReactElement => {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (!authState) return;

    const redirectToSignIn = async () => {
      if (!authState?.isAuthenticated) {
        const originalUri = toRelativeUrl(
          window.location.href,
          window.location.origin
        );

        await oktaAuth.setOriginalUri(originalUri);

        await oktaAuth.signInWithRedirect();
      }
    };

    redirectToSignIn();
  }, [authState, oktaAuth]);

  if (!authState || !authState?.isAuthenticated) {
    return <Loader />;
  }

  return <AuthModel>{children}</AuthModel>;
};

export default RequiredAuth;
